import React, { Component } from 'react'
import styled from 'styled-components'
import CheckboxSelected from '../icons/CheckboxSelected'
import CheckboxUnselected from '../icons/CheckboxUnselected'
import SvgCheckboxDisabledSelected from '../icons/CheckboxDisabledSelected'
import Text from '../Text/Text'
import { SCREEN_SIZE } from '../../lib/Media'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'

const FILTER_OPTION_LIMIT = 9

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem 1rem 0;
  > div > :nth-child(n + ${FILTER_OPTION_LIMIT}) {
    display: ${props => (props.view ? 'flex' : 'none')};
  }
`
const StyledImage = styled.div`
  padding: 0 0.5rem 0 1rem;
  transform: translateY(6%);
  color: ${defaultTheme.ColorBaseBrandPrimary500};
`

const DisabledText = styled(Text)`
  color: #cccccc;
  pointer-events: none;
`

const Div = styled.div`
  display: inline-flex;
  align-self: flex-start;
  cursor: pointer;

  > span {
    line-height: 2.5rem;

    ${SCREEN_SIZE.From.Desktop} {
      line-height: 1.25rem;
    }
  }
`

const DisabledDiv = styled.div`
  display: inline-flex;
  align-self: flex-start;
  pointer-events: none;

  > span {
    line-height: 2.5rem;

    ${SCREEN_SIZE.From.Desktop} {
      line-height: 1.25rem;
    }
  }
`

const ViewButton = styled.div`
  width: 100%;
  text-align: left;
  padding: 0.75rem 0.5rem 0 1rem;
  ${SCREEN_SIZE.From.Desktop} {
    padding: 0.625rem 0.5rem 0 1rem;
  }
  display: ${props => (props.view ? 'block' : 'none')};
`

const StyledText = styled(Text)`
  cursor: pointer;
`

const StyledFilterWrapper = styled.div`
  line-height: 2.5rem;

  ${SCREEN_SIZE.From.Desktop} {
    line-height: 1.25rem;
    margin: 0.125rem 0;

    :first-child {
      margin: 0 0 0.125rem;
    }
  }
`

const FilterCount = styled.span`
  font-size: 12px;
  font-weight: normal;
  line-height: 1.67;
  color: ${defaultTheme.ColorBaseMineShaft500};
  margin: 0 0 0 0.125rem;
`

class FilterList extends Component {
  constructor() {
    super()
    this.state = {
      isExpanded: false,
    }
    this.handleViewMore = this.handleViewMore.bind(this)
    this.handleViewLess = this.handleViewLess.bind(this)
  }

  handleViewMore() {
    this.setState({
      isExpanded: true,
    })
  }

  handleViewLess() {
    this.setState({
      isExpanded: false,
    })
  }
  render() {
    const { heading, displayType, checkedFilters, isEnabledApiExperiment } =
      this.props
    const filterTestId = heading
      ? `-${heading.replace(/\s/g, '-').toLowerCase()}`
      : ''

    const { isEnabled: isFilterCountEnabled } = getConfigFor(
      SPLIT_FEATURES.FE_JOURNEY_FILTER_COUNT
    )

    return (
      <Container
        data-testid={`filterList-${displayType}${filterTestId}`}
        view={this.state.isExpanded}
      >
        <div>
          {this.props.data.map((element, index) => {
            const isEnabledNewApiABTesting =
              isEnabledApiExperiment && !element.label
            const checked = isEnabledNewApiABTesting
              ? element.checked
              : checkedFilters && checkedFilters.includes(element.slug)
            return (
              <StyledFilterWrapper key={`filter-item-${index}`}>
                {element.disabled ? (
                  <DisabledDiv data-testid={`filter-item-${index}`}>
                    <StyledImage>
                      <SvgCheckboxDisabledSelected
                        data-testid={`disabled-checked-svg`}
                        height="16"
                        width="16"
                      />
                    </StyledImage>
                    <DisabledText size="medium">{element.name}</DisabledText>
                  </DisabledDiv>
                ) : (
                  <Div
                    tabIndex={0}
                    role="button"
                    aria-label="filter"
                    data-testid={`filter-item-${index}`}
                    onClick={() => this.props.onClick(element, heading)}
                    onKeyDown={e =>
                      (e.key === ' ' || e.key === 'Enter') &&
                      this.props.onClick(element, heading)
                    }
                  >
                    <StyledImage aria-hidden="true">
                      {checked ? (
                        <CheckboxSelected
                          data-testid={`checked-svg`}
                          height="16"
                          width="16"
                        />
                      ) : (
                        <CheckboxUnselected
                          data-testid={`unchecked-svg`}
                          height="16"
                          width="16"
                        />
                      )}
                    </StyledImage>
                    <Text
                      size="medium"
                      color={defaultTheme.ColorBaseMineShaft700}
                    >
                      <span>
                        {isEnabledNewApiABTesting
                          ? element.name
                          : element.label}
                      </span>
                      {isFilterCountEnabled && element?.count && (
                        <FilterCount data-testid={`filter-count-${index}`}>
                          ({element.count})
                        </FilterCount>
                      )}
                    </Text>
                  </Div>
                )}
              </StyledFilterWrapper>
            )
          })}
        </div>
        {this.props.data && this.props.data.length >= FILTER_OPTION_LIMIT && (
          <React.Fragment>
            <ViewButton view={!this.state.isExpanded}>
              <StyledText
                onClick={this.handleViewMore}
                size="medium"
                weight="bold"
                tabIndex={0}
                role="button"
                color={defaultTheme.ColorBaseBrandPrimary500}
                onKeyDown={e =>
                  (e.key === ' ' || e.key === 'Enter') && this.handleViewMore(e)
                }
              >
                View more
              </StyledText>
            </ViewButton>
            <ViewButton view={this.state.isExpanded}>
              <StyledText
                onClick={this.handleViewLess}
                size="medium"
                weight="bold"
                tabIndex={0}
                role="button"
                color={defaultTheme.ColorBaseBrandPrimary500}
                onKeyDown={e =>
                  (e.key === ' ' || e.key === 'Enter') && this.handleViewLess(e)
                }
              >
                View less
              </StyledText>
            </ViewButton>
          </React.Fragment>
        )}
      </Container>
    )
  }
}

FilterList.defaultProps = {
  isEnabledApiExperiment: false,
}

export default FilterList
